
import TipoGeometria from '@/models/tipoGeometria';

const COR_DESENHO = '#0066D5';

const COR_INSPECAO = '#FF3232';

export default class Estilo {
	
	static toMapStyle (estilo, drawing) {

		var style = {};

		if (estilo.contorno) {
			style.color = estilo.contorno.cor;
			style.weight = estilo.contorno.espessura;
			style.opacity = estilo.contorno.opacidade;
		}

		if (estilo.preenchimento) {
			style.fill = true;
			style.fillColor = estilo.preenchimento.cor;
			style.fillOpacity = estilo.preenchimento.opacidade;
		}

		if (drawing) {
			style.dashArray = '10,10';
			style.weight = 2;
		}

		if (estilo.raio) {
			style.radius = estilo.raio;

			if (drawing) {
				style.dashArray = null;
				style.fill = false;
				style.fillColor = null;
			}
		}

		return style;
	}

	static criarEstiloCamadaUsuario (cor, tipoGeometria) {

		var estilo = null;

		if (tipoGeometria.codigo === TipoGeometria.POLIGONO.codigo) {

			estilo = {
				contorno: {
					cor: cor,
					espessura: 1,
					opacidade: 1
				},
				preenchimento: {
					cor: cor,
					opacidade: 0.4
				}
			};

		} else if (tipoGeometria.codigo === TipoGeometria.LINHA.codigo) {

			estilo = {
				contorno: {
					cor: cor,
					espessura: 2,
					opacidade: 1
				}
			};

		} else if (tipoGeometria.codigo === TipoGeometria.PONTO.codigo) {

			estilo = {
				contorno: {
					cor: cor,
					espessura: 2,
					opacidade: 1
				},
				preenchimento: {
					cor: cor,
					opacidade: 0.8
				},
				raio: 4
			};
		}

		return estilo;
	}

	static getStyleDesenho (tipoGeometria, cor) {

		var estilo = this.criarEstiloCamadaUsuario(cor || COR_DESENHO, tipoGeometria);
		return this.toMapStyle(estilo, true);
	}

	static getStyleInspecao (tipoGeometria, cor) {

		return this.getStyleDesenho(tipoGeometria, cor || COR_INSPECAO);
	}
}



// WEBPACK FOOTER //
// ./src/models/estilo.js